export const TRANSCORP_STATES = ['CA'];
